import { getTlaShiftsPerWeek } from '@AMIEWEB/MarginTool/helper';
import { DurationType, FieldType, IconType, PreviewContainerFieldNames } from '../enum';

const PAY_PACKAGE_PREVIEW_NS = 'marginTool.payPackagePreview';

export const travelerContainerFields = [
  {
    fieldTitleKey: `${PAY_PACKAGE_PREVIEW_NS}.arrivingTravel`,
    fieldName: PreviewContainerFieldNames.arrivingTravel,
  },
  {
    fieldTitleKey: `${PAY_PACKAGE_PREVIEW_NS}.endingTravel`,
    fieldName: PreviewContainerFieldNames.endingTravel,
  },
  {
    fieldTitleKey: `${PAY_PACKAGE_PREVIEW_NS}.interimTravel`,
    fieldName: PreviewContainerFieldNames.interimTravel,
  },
  {
    fieldTitleKey: `${PAY_PACKAGE_PREVIEW_NS}.flight`,
    fieldName: PreviewContainerFieldNames.amnFlight,
  },
  {
    fieldTitleKey: `${PAY_PACKAGE_PREVIEW_NS}.rentalCar`,
    fieldName: PreviewContainerFieldNames.amnRentalCar,
  },
];

export const weeklyTotalFields = [
  {
    fieldTitleKey: `${PAY_PACKAGE_PREVIEW_NS}.payRate`,
    fieldName: PreviewContainerFieldNames.payRate,
    IconType: IconType.Tax,
    durationType: DurationType.hr,
  },
  {
    fieldTitleKey: `${PAY_PACKAGE_PREVIEW_NS}.overtimeRate`,
    fieldName: PreviewContainerFieldNames.overTimeRate,
    IconType: IconType.Tax,
    durationType: DurationType.hr,
  },
  {
    fieldTitleKey: `${PAY_PACKAGE_PREVIEW_NS}.premiumPayRate`,
    fieldName: PreviewContainerFieldNames.premiumPayRate,
    IconType: IconType.Tax,
    durationType: DurationType.hr,
  },
  {
    fieldTitleKey: `${PAY_PACKAGE_PREVIEW_NS}.doubletimeRate`,
    fieldName: PreviewContainerFieldNames.doubletimeRate,
    IconType: IconType.Tax,
    durationType: DurationType.hr,
  },
  {
    fieldTitleKey: `${PAY_PACKAGE_PREVIEW_NS}.lodging`,
    fieldName: PreviewContainerFieldNames.lodgingPerDiem,
    IconType: IconType.NonTax,
    durationType: DurationType.day,
  },
  {
    fieldTitleKey: `${PAY_PACKAGE_PREVIEW_NS}.meal`,
    fieldName: PreviewContainerFieldNames.mealPerDiem,
    IconType: IconType.NonTax,
    durationType: DurationType.day,
  },
  {
    fieldTitleKey: `${PAY_PACKAGE_PREVIEW_NS}.cellPhoneStipend`,
    fieldName: PreviewContainerFieldNames.cellPhoneStipend,
    IconType: IconType.NonTax,
    durationType: DurationType.day,
  },
  {
    fieldTitleKey: `${PAY_PACKAGE_PREVIEW_NS}.carAllowance`,
    fieldName: PreviewContainerFieldNames.tlaCarAllowance,
    IconType: IconType.Tax,
    durationType: DurationType.shift,
  },
  {
    fieldTitleKey: `${PAY_PACKAGE_PREVIEW_NS}.mealAllowance`,
    fieldName: PreviewContainerFieldNames.tlaMealAllowance,
    IconType: IconType.Tax,
    durationType: DurationType.shift,
  },
  {
    fieldTitleKey: `${PAY_PACKAGE_PREVIEW_NS}.shiftCompletionBonus`,
    fieldName: PreviewContainerFieldNames.tlaShiftCompletionBonus,
    IconType: IconType.Tax,
    durationType: DurationType.shift,
  },
  {
    fieldTitleKey: `${PAY_PACKAGE_PREVIEW_NS}.cellPhoneStipend`,
    fieldName: PreviewContainerFieldNames.tlaCellPhoneStipend,
    IconType: IconType.NonTax,
    durationType: DurationType.shift,
  },
];

export const amnHousingFields = [
  {
    fieldTitleKey: `${PAY_PACKAGE_PREVIEW_NS}.amnHousing`,
    fieldName: PreviewContainerFieldNames.housingType,
    fieldType: FieldType.string,
  },
  {
    fieldTitleKey: `${PAY_PACKAGE_PREVIEW_NS}.additionalFurniture`,
    fieldName: PreviewContainerFieldNames.additionalFurniture,
    fieldType: FieldType.number,
  },
  {
    fieldTitleKey: `${PAY_PACKAGE_PREVIEW_NS}.housingCoPay`,
    fieldName: PreviewContainerFieldNames.housingCoPay,
    fieldType: FieldType.number,
  },
  {
    fieldTitleKey: `${PAY_PACKAGE_PREVIEW_NS}.furnitureCoPay`,
    fieldName: PreviewContainerFieldNames.furnitureCoPay,
    fieldType: FieldType.number,
  },
  {
    fieldTitleKey: `${PAY_PACKAGE_PREVIEW_NS}.earlyMoveInDate`,
    fieldName: PreviewContainerFieldNames.earlyMoveInDate,
    fieldType: FieldType.date,
  },
  {
    fieldTitleKey: `${PAY_PACKAGE_PREVIEW_NS}.lateMoveOutDate`,
    fieldName: PreviewContainerFieldNames.lateMoveOutDate,
    fieldType: FieldType.date,
  },
];

export const getWeeklyCalculatedValue = (fieldName, fieldValue, hoursPerWeek, hoursPerShift) => {
  switch (fieldName) {
    case PreviewContainerFieldNames.lodgingPerDiem: {
      return fieldValue * 7;
    }
    case PreviewContainerFieldNames.mealPerDiem: {
      return fieldValue * 7;
    }
    case PreviewContainerFieldNames.cellPhoneStipend: {
      return fieldValue * 7;
    }
    case PreviewContainerFieldNames.tlaCarAllowance: {
      return fieldValue * getTlaShiftsPerWeek(hoursPerWeek, hoursPerShift);
    }
    case PreviewContainerFieldNames.tlaMealAllowance: {
      return fieldValue * getTlaShiftsPerWeek(hoursPerWeek, hoursPerShift);
    }
    case PreviewContainerFieldNames.tlaShiftCompletionBonus: {
      return fieldValue * getTlaShiftsPerWeek(hoursPerWeek, hoursPerShift);
    }
    case PreviewContainerFieldNames.tlaCellPhoneStipend: {
      return fieldValue * getTlaShiftsPerWeek(hoursPerWeek, hoursPerShift);
    }
  }
};

export const getFieldValue = ({ fieldName, currSplitRates, eachSplit }) => {
  const splitPayRate = Number(eachSplit?.payRate) || 0;
  const payOvertimeFactor = Number(eachSplit?.payOvertimeFactor) || 0;
  const additionalPremiumPay =
    eachSplit?.additionalPremiumPay?.object?.id === 0 //id= 0 -> None
      ? 0
      : Number(eachSplit.additionalPremiumPay?.object?.description);
  const payDoubletimeFactor = Number(eachSplit?.payDoubletimeFactor) || 0;
  switch (fieldName) {
    case PreviewContainerFieldNames.payRate: {
      return splitPayRate;
    }
    case PreviewContainerFieldNames.overTimeRate: {
      //overtime factor * pay rate
      return payOvertimeFactor * splitPayRate;
    }
    case PreviewContainerFieldNames.premiumPayRate: {
      //Additional Premium Pay *  Pay Rate
      const overtimeRate = payOvertimeFactor * splitPayRate;
      const premiumPayRate = additionalPremiumPay * splitPayRate;
      return premiumPayRate - overtimeRate;
    }
    case PreviewContainerFieldNames.doubletimeRate: {
      //Doubletime Factor *  Pay Rate
      return payDoubletimeFactor * splitPayRate;
    }
  }
};
function noOvertimeOrDoubleTime(payOvertimeHours: number, payDoubletimeHours: number) {
  return !payOvertimeHours && !payDoubletimeHours;
}

function hoursExceedLimit(hoursPerWeek: number, payOvertimeLimitWeek: number) {
  return hoursPerWeek >= payOvertimeLimitWeek;
}
function getFormattedValue(value: number) {
  return value < 0 ? 0 : value;
}
export function getOverTimeRate({ payOvertimeHours, payDoubletimeHours, payOvertimeFactor, splitPayRate }) {
  if (noOvertimeOrDoubleTime(payOvertimeHours, payDoubletimeHours)) {
    return 0;
  }
  return getFormattedValue((payOvertimeHours - payDoubletimeHours) * payOvertimeFactor * splitPayRate);
}

export function getDoubleTimeRate({ payOvertimeHours, payDoubletimeHours, payDoubletimeFactor, splitPayRate }) {
  if (noOvertimeOrDoubleTime(payOvertimeHours, payDoubletimeHours)) {
    return 0;
  }
  return getFormattedValue(payDoubletimeHours * payDoubletimeFactor * splitPayRate);
}

export function getPremiumPayRate({ additionalPremiumPay, splitPayRate, payOvertimeFactor, payPremiumHours }) {
  return !additionalPremiumPay
    ? 0
    : getFormattedValue(payPremiumHours * splitPayRate * (additionalPremiumPay - payOvertimeFactor));
}

export const getRatesWeeklyCalculatedValue = ({ fieldName, currSplitRates, eachSplit, hoursPerWeek }) => {
  const splitPayRate = Number(eachSplit?.payRate) || 0;
  const payDoubletimeHours = currSplitRates?.payDoubletimeHours || 0;
  const payOvertimeHours = currSplitRates?.payOvertimeHours || 0;
  const payOvertimeLimitWeek = currSplitRates?.payOvertimeLimitWeek || 0;
  const payPremiumHours = currSplitRates?.payPremiumHours || 0;
  const payOvertimeFactor = Number(eachSplit?.payOvertimeFactor) || 0;
  const payDoubletimeFactor = Number(eachSplit?.payDoubletimeFactor) || 0;
  const additionalPremiumPay =
    eachSplit?.additionalPremiumPay?.object?.id === 0
      ? 0
      : Number(eachSplit?.additionalPremiumPay?.object?.description);

  switch (fieldName) {
    case PreviewContainerFieldNames.payRate: {
      if (payOvertimeHours > 0) {
        const val =  (hoursPerWeek - payOvertimeHours) * splitPayRate  
        return val < 0 ? 0 : val;
      }
      return splitPayRate * hoursPerWeek; //existing logic
    }

    case PreviewContainerFieldNames.overTimeRate: {
      return getOverTimeRate({ payOvertimeHours, payDoubletimeHours, payOvertimeFactor, splitPayRate });
    }

    case PreviewContainerFieldNames.doubletimeRate: {
      return getDoubleTimeRate({ payOvertimeHours, payDoubletimeHours, payDoubletimeFactor, splitPayRate });
    }

    case PreviewContainerFieldNames.premiumPayRate: {
      return getPremiumPayRate({
        additionalPremiumPay,
        splitPayRate,
        payOvertimeFactor,
        payPremiumHours,
      });
    }
    default:
      return 0;
  }
};

export const getSubTextValues = ({ fieldName, currSplitRates, fieldValue }) => {
  const {
    payOvertimeLimitDay = 0,
    payOvertimeLimitWeek = 0,
    payDoubletimeLimitDay = 0,
    payDoubletimeLimitWeek = 0,
  } = currSplitRates || {};

  const createSubText = (dailyLimit: number, weeklyLimit: number) => ({
    dailyValue: fieldValue,
    weeklyValue: fieldValue,
    dailyHours: dailyLimit,
    weeklyHours: weeklyLimit,
    enableDaily: dailyLimit > 0,
    enableWeekly: weeklyLimit > 0,
  });

  switch (fieldName) {
    case PreviewContainerFieldNames.overTimeRate:
      return createSubText(payOvertimeLimitDay, payOvertimeLimitWeek);
    case PreviewContainerFieldNames.premiumPayRate:
      return {
        dailyValue: fieldValue,
        weeklyValue: fieldValue,
        dailyHours: payOvertimeLimitDay,
        weeklyHours: payOvertimeLimitWeek,
        enableDaily: false,
        enableWeekly: payOvertimeLimitWeek > 0,
      };
    case PreviewContainerFieldNames.doubletimeRate:
      return createSubText(payDoubletimeLimitDay, payDoubletimeLimitWeek);

    case PreviewContainerFieldNames.payRate:
    default:
      return null;
  }
};

export const formattedNumber = (value: string) => {
  return value?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const ValueAccumulator = (fieldValue: string[]) => {
  return fieldValue
    ?.filter(item => item !== undefined)
    ?.map(Number)
    ?.reduce((acc, curr) => acc + curr, 0);
};
